import React from 'react';

class TradeNowButtonItem extends React.Component {

    constructor(props) {
        super(props);

        this.initialState = {
            styleClass: ['button', 'button-block-fit'],
            buttontext: '',
            buttonAction: () => null,
            hovering: false,
            hoveringText: null,
        }

        this.state = this.initialState;

        this.setButtonParams = this.setButtonParams.bind(this);
        this.refreshButton = this.refreshButton.bind(this);
    }

    componentDidMount() {
        this.refreshButton(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const { status, intent, type, isOwner, contractType, showTraded, isExpired, glow, label } = this.props;
        
        if (nextProps.status !== status || nextProps.intent !== intent ||
            nextProps.type !== type || nextProps.isOwner !== isOwner ||
            nextProps.contractType !== contractType || nextProps.showTraded !== showTraded ||
            nextProps.isExpired !== isExpired || nextProps.glow !== glow ||
            nextProps.label !== label) {
            this.setState(this.initialState, () => this.refreshButton(nextProps));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // update only on state change
        const { styleClass, hovering } = this.state;

        if (nextState.styleClass !== styleClass || nextState.hovering !== hovering) {
            return true;
        }

        return false;
    }

    refreshButton(props) {
        let { status, intent, type, isOwner, contractType, id, user, showTraded, glow } = props;

        let isSuperUser = user.isAdmin || user.isSuperUser,
        hideCme = !user.userInfo.cme_cleared && contractType == 'CME',
        isExpired = (status === 'EXPIRED' || props.isExpired);

        if (isSuperUser) {
            this.setButtonParams(showTraded ? 'edit_finalised' : intent.toLowerCase(), type, intent, glow);
        } else {
            if (hideCme) {
                this.setButtonParams('view', type, intent, glow);
            } else if (showTraded) {
                this.setButtonParams('view_traded', type, intent, glow);
            } else {
                if (type == 'DH Broker' || isExpired) {                    
                    this.setButtonParams(isOwner ? 'edit' : intent.toLowerCase()+'_broker', type, intent, glow);                
                } else {
                    this.setButtonParams(isOwner ? 'edit' : intent.toLowerCase(), type, intent, glow);
                }
            }
        }
    }

    viewOrder(id, mode) {
        let { showOrderPopup, getOrder } = this.props;
        getOrder(id, mode, showOrderPopup);
    }

    setButtonParams(option, type, intent, glow) {
        let iconClass = '';
        if (type == 'DH Broker') iconClass = 'icon-broker';
        if (type == 'DH Ghost') iconClass = 'icon-ghost';

        const placeOrder = () => this.props.placeOrder(this.props.row);
        const callDH = () => this.props.callDH(this.props.row);
        const { label } = this.props;

        const sets = {
            buy: {
                buttontext: 'Bid',
                hoveringText: 'Sell it',
                styleClass: `button-sell ${iconClass} ${glow ? 'button-glow' : ''}`,
                buttonAction: placeOrder,
            },
            sell: {
                buttontext: 'Offer',
                hoveringText: 'Buy it',
                styleClass: `button-buy ${iconClass} ${glow ? 'button-glow' : ''}`,
                buttonAction: placeOrder,
            },
            buy_broker: {
                buttontext: 'Bid',
                hoveringText: 'Sell it',
                styleClass: `button-sell icon-broker ${glow ? 'button-glow' : ''}`,
                buttonAction: callDH,
            },
            sell_broker: {
                buttontext: 'Offer',
                hoveringText: 'Buy it',
                styleClass: `button-buy icon-broker ${glow ? 'button-glow' : ''}`,
                buttonAction: callDH,
            },
            view: {
                buttontext: intent === 'BUY' ? 'View bid' : 'View offer',
                styleClass: `${glow ? 'button-glow' : ''}`,
                buttonAction: this.viewOrder.bind(this, this.props.id, 'view'),
            },
            view_traded: {
                buttontext: 'View',
                styleClass: `${glow ? 'button-glow' : ''}`,
                buttonAction: this.viewOrder.bind(this, this.props.id, 'view'),
            },
            edit: {
                buttontext: intent === 'BUY' ? 'Edit bid' : 'Edit offer',
                hoveringText: intent === 'BUY' ? 'Edit bid' : 'Edit offer',
                styleClass: `button-edit ${glow ? 'button-glow' : ''}`,
                buttonAction: this.viewOrder.bind(this, this.props.id, 'edit'),
            }, 
            edit_finalised: {
                buttontext: 'View', // intent === 'BUY' ? 'Edit bid' : 'Edit offer',
                styleClass: `${glow ? 'button-glow' : ''}`,
                buttonAction: this.viewOrder.bind(this, this.props.id, 'edit-finalised'),
            },            
            blank: {
                buttontext: '-',
                styleClass: 'button-blank',
                buttonAction: () => null,
            }
        }

        const styleClass = [...this.state.styleClass];
        styleClass.push(sets[option].styleClass);
        
        this.setState({
            styleClass,
            buttontext: label ? label : sets[option].buttontext,
            buttonAction: sets[option].buttonAction,
            hoveringText: sets[option].hoveringText,
        });
    }

	render() {
        const { buttonAction, styleClass, hovering, buttontext, hoveringText } = this.state;

        return (
            <button 
                onClick={buttonAction}
                onMouseEnter={() => this.setState({ hovering: true })}
                onMouseLeave={() => this.setState({ hovering: false })}
                className={styleClass.join(' ') + (hovering ? ' hovering' : '')}>
                <span className='normal-text'>{buttontext}</span>     
                <span className='hovering-text'>{buttontext !== hoveringText ? hoveringText : ''}</span>
                <div className='overlay'></div>                
            </button>
        )
    }
}

export default TradeNowButtonItem;



// WEBPACK FOOTER //
// ./source/screens/markets/tradeNowButton.js